import React from 'react';
import BaseCard from './BaseCard';
import LineChart from '../../common/lineChart';
import { ProgressBar } from 'primereact/progressbar';
import PlusImg from '../../../assets/images/plus.svg';
import UpImg from '../../../assets/images/up.svg';
import './AppointmentsCard.scss';

function AppointmentsCard({ rangeDetails, graphData }) {
  const iconMapping = {
    new: PlusImg,
    follow_up: UpImg,
  };

  const progressColor = {
    new: "rgba(40, 44, 135, 1)",
    follow_up: "rgba(0, 186, 209, 1)",
  };

  const defaultAppointmentData = {
    totalAppointment: 0,
    labels: [],
    data: [],
    visitDetails: [
      {
        purpose: "New",
        nativeName: "new",
        visit_count: 0,
      },
      {
        purpose: "Follow Up",
        nativeName: "follow_up",
        visit_count: 0,
      },
    ],
  };

  // Ensure we have valid data with defaults
  const appointmentData = graphData?.appointment || defaultAppointmentData;
  const visitDetails = appointmentData.visitDetails || defaultAppointmentData.visitDetails;
  const totalAppointment = appointmentData.totalAppointment || 0;

  // Check if we have any meaningful data
  const hasData = totalAppointment > 0 || 
    appointmentData.data?.some(value => value > 0) || 
    visitDetails.some(item => item.visit_count > 0);

  if (!hasData) {
    return (
      <BaseCard 
        title="Camp Visits"
        className="appointments-card"
      >
        <div className="appointments-card__no-data">
          No Data
        </div>
      </BaseCard>
    );
  }

  return (
    <BaseCard 
      title="Camp Visits"
      subtitle="Overview"
      className="appointments-card"
    >
      <div className="appointments-card__content">
        <div className="appointments-card__header">
          <div className="appointments-card__info">
            <p className="appointments-card__total">
              {totalAppointment}
            </p>
            <span className="appointments-card__subtitle">
              Total Appointments {rangeDetails || 'Today'}
            </span>
          </div>
          {appointmentData.data?.length > 0 && (
            <div className="appointments-card__chart">
              <LineChart graphData={appointmentData} />
            </div>
          )}
        </div>
        <div className="appointments-card__stats">
          {visitDetails.map((item, index) => (
            <div className="appointments-card__stat-item" key={index}>
              <p className="appointments-card__stat-header">
                <span>
                  <img src={iconMapping[item?.nativeName]} alt="" />
                </span>
                <span className="appointments-card__stat-label">
                  {item?.purpose}
                </span>
              </p>
              <div>
                <span className="appointments-card__stat-value">
                  {item?.visit_count || 0}
                </span>
                <div className="appointments-card__progress">
                  <ProgressBar
                    value={
                      totalAppointment > 0
                        ? (item?.visit_count / totalAppointment) * 100
                        : 0
                    }
                    color={progressColor[item?.nativeName]}
                    style={{
                      height: "4px",
                      backgroundColor: "rgba(47, 43, 61, 0.08)",
                    }}
                    showValue={false}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </BaseCard>
  );
}

export default React.memo(AppointmentsCard); 